import { api } from "~/utils/api";
import { Emdash } from "~/components/Punctuation";

// // // //

export function BroadridgeAssetCountCell() {
    const { data, isLoading } =
        api.platforms.queryBroadridgeAssetCount.useQuery();

    if (isLoading) {
        return <Emdash />;
    }

    if (!data) {
        return <Emdash />;
    }

    return <span>{data.count.toLocaleString()}</span>;
}
